import * as termsService from "services/terms-service";

export const getPendingTermsAction = () => async () => {
    return await termsService.getPendingTerms();
};

export const getTermPreviewAction = (termVersionId) => async () => {
    return await termsService.getTermPreview(termVersionId);
};

export const acceptTermsAction = (channel = "backoffice") => async () => {
    return await termsService.acceptTerms(channel);
};
